import { Duration } from 'luxon';
import { OrderPointType } from '../../../dashboard/orders/common/enums/order-point-type';
import { TransitOperator } from '../../enums/transit/transit-operator';
import type { TransitRoute } from '../../interfaces/transit/transit-route';
import { TUNNELS } from './tunnels';
import { TransitFrequencyInterval } from '../../enums/transit/transit-frequency-interval';

export const TUNNEL_ROUTES: TransitRoute[] = [
  /* France */
  // Fréjus Tunnel - France
  {
    uuid: '89063b5d-0cd1-4241-88a6-cd411f7227bd',
    type: OrderPointType.TUNNEL,
    from: TUNNELS.frejusTunnelFrance,
    to: TUNNELS.frejusTunnelItaly,
    operator: TransitOperator.MONT_BLANC_AND_FREJUS_TUNNELS,
    frequency: { interval: TransitFrequencyInterval.MANY, value: null },
    duration: Duration.fromObject({ minutes: 20 }).as('seconds'),
  },
  // Mont Blanc Tunnel - France
  {
    uuid: 'e4834360-fdbc-4d8c-9744-4fa1c09cd911',
    type: OrderPointType.TUNNEL,
    from: TUNNELS.montBlancTunnelFrance,
    to: TUNNELS.montBlancTunnelItaly,
    operator: TransitOperator.MONT_BLANC_AND_FREJUS_TUNNELS,
    frequency: { interval: TransitFrequencyInterval.MANY, value: null },
    duration: Duration.fromObject({ minutes: 20 }).as('seconds'),
  },

  /* Italy */
  // Fréjus Tunnel - Italy
  {
    uuid: 'c27b9dbd-2197-401a-a797-18484430a93f',
    type: OrderPointType.TUNNEL,
    from: TUNNELS.frejusTunnelItaly,
    to: TUNNELS.frejusTunnelFrance,
    operator: TransitOperator.MONT_BLANC_AND_FREJUS_TUNNELS,
    frequency: { interval: TransitFrequencyInterval.MANY, value: null },
    duration: Duration.fromObject({ minutes: 20 }).as('seconds'),
  },
  // Mont Blanc Tunnel - Italy
  {
    uuid: '51ca43cd-d289-4e97-a8e3-f7bee1b899da',
    type: OrderPointType.TUNNEL,
    from: TUNNELS.montBlancTunnelItaly,
    to: TUNNELS.montBlancTunnelFrance,
    operator: TransitOperator.MONT_BLANC_AND_FREJUS_TUNNELS,
    frequency: { interval: TransitFrequencyInterval.MANY, value: null },
    duration: Duration.fromObject({ minutes: 20 }).as('seconds'),
  },
] as const;
